import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { Extension } from '@tiptap/react';

export const WrapContentInSpan = Extension.create({
  name: 'wrapContentInSpan',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('wrapContentInSpan'),
        props: {
          decorations: state => {
            const { doc } = state;
            const decorations: Decoration[] = [];

            doc.descendants((node, pos) => {
              if (node.type.name === 'paragraph') {
                let lastPos = pos + 1; // +1 to skip the paragraph start
                let lastStyle = '';
                let hasTextStyleAtEnd = false;

                node.content.forEach((child, offset, index) => {
                  if (child.isText) {
                    const mark = child.marks.find(m => m.type.name === 'textStyle');
                    const currentStyle = mark?.attrs?.style || '';

                    // Check if this is the last text node
                    if (index === node.content.childCount - 1) {
                      hasTextStyleAtEnd = !!mark;
                    }

                    if (currentStyle !== lastStyle) {
                      if (lastPos < pos + 1 + offset) {
                        decorations.push(
                          Decoration.inline(lastPos, pos + 1 + offset, { nodeName: 'span', style: lastStyle })
                        );
                      }
                      lastPos = pos + 1 + offset;
                      lastStyle = currentStyle;
                    }
                  }
                });

                // Add a new span if there isn't one already
                if (!hasTextStyleAtEnd && lastPos < pos + node.nodeSize - 1) {
                  decorations.push(
                    Decoration.inline(lastPos, pos + node.nodeSize - 1, { nodeName: 'span', style: lastStyle })
                  );
                }
              }
            });

            return DecorationSet.create(doc, decorations);
          }
        }
      })
    ];
  }
});
